import { EPlanLimitType } from '@app/domain/plan/components/plan-limit-dialog/PlanLimitDialog';
import { ETrialOnboardingType } from '@app/modules/customer/components/onboarding/TrialOnboardingDialog';

export const marketingSelectors = {
  getLimitDialogButtonId: (limitType: EPlanLimitType) => limitType,
  getTrialOnboardingButtonId: (trialOnboarding: ETrialOnboardingType) => trialOnboarding,
  onboardingDialog: {
    discountButtonId: 'ONBOARDING_DISCOUNT',
  },
};
